export default {"src":"/_next/static/image/public/images/ic_left_pagination_arrow_purple.612ea3c8b88b94449f5ee6cf3791508f.svg","height":15,"width":8};